<template>
  <div class="list__action__item--content">
    <div class="flex-row flex__between">
      <p class="name margin-0">
        {{ action.creatorName }}
      </p>
      <div class="time font-size__small">
        <i class="fal fa-clock">
          {{ action.createTime | convertToLabelFilter }}
        </i>
      </div>
    </div>
    <div>
      <p
        :class="['action-type flex-row flex__left inline-flex', 'color__green']"
      >
        <i :class="['font-size__small', 'fal fa-edit']"></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ "Cho ý kiến" }}
        </span>
      </p>
      <div
        v-if="action.data.comment"
        class="content__message--text content__message--item"
      >
        <el-input
          type="textarea"
          resize="none"
          ref="inputComment"
          autosize
          v-model.trim="action.data.comment"
          disabled
          class="input-display__comment style-fullWidth input-none__border bg__transparent"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";

  export default {
    name: "history-cho-y-kien",
    props: ["action"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {};
    },
    created() {
    },
    methods: {}
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/history-cho-y-kien.vue